import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./locales/en/translation.json";
import jaTranslation from "./locales/ja/translation.json";
import zhTranslation from "./locales/zh/translation.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  ja: {
    translation: jaTranslation,
  },
  zh: {
    translation: zhTranslation,
  },
};

function detectInitialLanguage(): "ja" | "en" | "zh" {
  if (typeof navigator === "undefined") return "en";
  const langs = (navigator.languages && navigator.languages.length
    ? navigator.languages
    : [navigator.language || ""]) as string[];
  const lowered = langs.map((l) => (l || "").toLowerCase());
  for (const l of lowered) {
    if (l.startsWith("ja")) return "ja";
    if (l.startsWith("zh")) return "zh"; // zh-CN, zh-TW などを包括
    if (l.startsWith("en")) return "en";
  }
  return "en"; // 未対応は英語へフォールバック
}

i18n.use(initReactI18next).init({
  resources,
  lng: detectInitialLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
